import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ffq-lib',
  template: `
    <p>
      ffq-lib works!
    </p>
  `,
  styles: []
})
export class FfqLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
